import type { LandingPage } from '@tipi/shared'

export const FOOD_COST_LANDING_PAGE: LandingPage = 'food-cost'

export const FORM_HASH = '#form'
export const FAQS_HASH = '#faqs'

export const OUTBOUND_TRACK_OPTIONS = { transport: 'sendBeacon' as const, send_immediately: true }

const ENCODED = '/food-cost/encoded'

export type CharacterEntryHeight = 'top' | 'center' | 'bottom'

export const CHROMA_KEY_SETTINGS = {
    threshold: 45,
    greenRatio: 1.4,
    spillRange: 28,
    spillStrength: 0.95,
    minGreenExcess: 6,
} as const

export const ASSETS = {
    headerLogo: '/food-cost/tipi-logo-orange-header.webp',
    videoEnteringFromRightSource: '/food-cost/entrando-por-la-derecha.mp4',
    videoEnteringFromRightPoster: `${ENCODED}/entrando-por-la-derecha-poster.webp`,
    heroVideoSource: '/food-cost/saliendo-de-la-pared.mp4',
    heroVideoPoster: `${ENCODED}/saliendo-de-la-pared-poster.webp`,
    pricingPhoto: '/food-cost/auditoria-cocina.webp',
    map: '/food-cost/mapa-clientes-tipi.webp',
    lanzaderaLogo: '/food-cost/lanzadera.webp',
    whatIsTipiCharacter: '/food-cost/tipi-character-glasses.webp',
} as const

export const PRICING_MONTHLY_BASE_FEE_EUR = 39
export const PRICING_PER_ALBARAN_EUR = 0.7
export const PRICING_INCLUDED_ALBARANES = 5
export const PRICING_AVG_ALBARANES_PER_MONTH = 60
export const PRICING_ALBARANES_INPUT_MAX = 999

export const formatEur = (value: number, locale: string, fractionDigits?: number) => {
    const digits = fractionDigits ?? (Number.isInteger(value) ? 0 : 2)
    const formatted = new Intl.NumberFormat(locale.startsWith('en') ? 'en-GB' : 'es-ES', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    }).format(value)
    return `${formatted} €`
}

const PRICING_MONTHLY_BASE_FEE_CENTS = Math.round(PRICING_MONTHLY_BASE_FEE_EUR * 100)
const PRICING_PER_ALBARAN_CENTS = Math.round(PRICING_PER_ALBARAN_EUR * 100)

export const getBillableAlbaranes = (albaranes: number) => {
    const safeCount = Math.max(0, Math.floor(albaranes))
    return Math.max(0, safeCount - PRICING_INCLUDED_ALBARANES)
}

export const calcExtrasFeeFromAlbaranes = (albaranes: number) =>
    (getBillableAlbaranes(albaranes) * PRICING_PER_ALBARAN_CENTS) / 100

/** Monthly fee in euros: base (includes 5 albaranes) + 0.70 € per extra (integer cents). */
export const calcMonthlyFeeFromAlbaranes = (albaranes: number) =>
    (PRICING_MONTHLY_BASE_FEE_CENTS + getBillableAlbaranes(albaranes) * PRICING_PER_ALBARAN_CENTS) / 100

export const SIDE_CHROMA_KEY_SETTINGS = {
    threshold: 38,
    greenRatio: 1.35,
    spillRange: 24,
    spillStrength: 0.9,
    minGreenExcess: 5,
} as const

export const CHARACTER_SECTION_HEIGHTS: CharacterEntryHeight[] = [
    'bottom',
    'center',
    'center',
    'top',
    'bottom',
    'center',
    'center',
]
